<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dIXNGP/tc-custom/9781429952637.jpg?1731208376474" alt="This image is the cover for the book Jane's Fame"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jane's Fame
      </h1>
      <p class="bookDescription body article font2">
        <i>Jane's Fame</i> tells the fascinating story of Jane Austen's renown, from the years of rejection the author faced during her lifetime to the global recognition and adoration she now enjoys. Almost two hundred years after her death, Austen remains a hot topic, constantly open to revival and reinterpretation and known to millions of people through film and television adaptations as much as through her books. In <i>Jane's Fame,</i> Claire Harman gives us the complete biography—of both the author and her lasting cultural influence—making this essential reading for anyone interested in Austen's life, works, and remarkably potent fame.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claire Harman
      </h2>
      
      <p class="authorDescription body article"><B>Claire Harman</B> is the author of <I>Sylvia Townsend Warner</I>, which won the John Llewellyn Rhys Prize; <I>Fanny Burney</I>, which was short-listed for the Whitbread Prize, and the critically acclaimed <I>Robert Louis Stevenson</I>. Elected a Fellow of the Royal Society of Literature in 2006, Harman teaches at the universities of Manchester and Oxford in England and Columbia University in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d378f72e